import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BaseComponent } from '../core/base/base.component';
import { CreateSiteInfoApiClientComponent } from './create-siteinfo-api-client/create-siteinfo-api-client.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { ListApiResourcesComponent } from './list-api-resoruces/list-api-resources.component';
import { ClientDetailsComponent } from './client-details/client-details.component';
import { ListClientsComponent } from './list-clients/list-clients.component';
import { ListIdentityResourcesComponent } from './list-identity-resoruces/list-identity-resources.component';
import { ListUsersComponent } from './list-users/list-users.component';

@NgModule({
    declarations: [
    ],
    imports: [
        RouterModule.forRoot([
    {
        path: '', component: BaseComponent, children: [
            {
                path: 'listUsers',
                component: ListUsersComponent,
                data: {
                    title: 'List Users'
                }
                //canActivate: [Guard]
            }
        ]
    },
    {
        path: '', component: BaseComponent, children: [
            {
                path: 'createUser',
                component: CreateUserComponent,
                data: {
                    title: 'Add New User'
                }
                //canActivate: [Guard]
            }
        ]
    },
    {
        path: '', component: BaseComponent, children: [
            {
                path: 'listClients',
                component: ListClientsComponent,
                data: {
                    title: 'List Clients'
                }
                //canActivate: [Guard]
            }
        ]
    },
    {
        path: '', component: BaseComponent, children: [
            {
                path: 'clients/:clientId/details',
                component: ClientDetailsComponent,
                data: {
                    title: 'Client Details'
                }
                //canActivate: [Guard]
            }
        ]
    },
    {
        path: '', component: BaseComponent, children: [
            {
                path: 'createClient',
                component: CreateSiteInfoApiClientComponent,
                data: {
                    title: 'Add New SiteInfo API Client'
                }
                //canActivate: [Guard]
            }
        ]
    },
    {
        path: '', component: BaseComponent, children: [
            {
                path: 'listIdentityResources',
                component: ListIdentityResourcesComponent,
                data: {
                    title: 'List Identity Resources'
                }
                //canActivate: [Guard]
            }
        ]
    },
    {
        path: '', component: BaseComponent, children: [
            {
                path: 'listResources',
                component: ListApiResourcesComponent,
                data: {
                    title: 'List Resources'
                }
                //canActivate: [Guard]
            }
        ]
    }
], {})
    ]
})
export class UserManagerRoutingModule {
}



